import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=4918bafe&scoped=true"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"
import style0 from "./Sort.vue?vue&type=style&index=0&id=4918bafe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4918bafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4918bafe')) {
      api.createRecord('4918bafe', component.options)
    } else {
      api.reload('4918bafe', component.options)
    }
    module.hot.accept("./Sort.vue?vue&type=template&id=4918bafe&scoped=true", function () {
      api.rerender('4918bafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/ui/components/table/Sort.vue"
export default component.exports